import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { environment } from 'src/environments/environment';
import { Observable, Subject, map } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms';
import { helper } from 'src/environments/helper';
import { RegistreService } from '../registre.service';
import { GenericRegister } from 'src/app/interfaces/generic.interface';

@Component({
    selector: 'app-registre-urbanism',
    templateUrl: './registre-urbanism.component.html',
    styleUrls: ['./registre-urbanism.component.scss']
})
export class RegistreUrbanismComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    @Output() backToRegistreClicked = new EventEmitter();

    portalLive: boolean = environment.portalLive;

    isLoading = false;
    helper = helper;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink = environment.interop.urbanismCore.basePath + environment.interop.urbanismCore.registre.getRegistreDT;

    registre$!: Observable<GenericRegister[]>;

    paramsForm!: FormGroup;

    defaultParameter: { name: string; slug: string } = {
        name: '-- Alegeți --',
        slug: '-1',
    }

    startYear = 2026;
    currentYear = new Date().getFullYear();
    valabilitateFilteringOptions: number[] = Array.from(
        { length: this.currentYear - this.startYear + 1 },
        (_, i) => this.startYear + i
    );

    selectedSlug: string = '-1';
    selectedValabilitate: number = this.currentYear;

    step: number = 1;
    tipRegistru: string = '';

    constructor(
        private http: HttpClient,
        private registreService: RegistreService,
    ) { }

    ngOnInit(): void {
        this.initParamsForm();
        this.renderDT();
        this.loadRegistre();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    initParamsForm() {
        this.paramsForm = new FormGroup({
            type: new FormControl('-1'),
            valabilitate: new FormControl(this.currentYear)
        })
    }

    onTypeChange(selectedType: string) {
        this.selectedSlug = selectedType;
        if (selectedType !== '-1') {
            this.rerenderDT();
        } else {
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.clear().destroy();
                this.dtTrigger.next('');
            });
        }
    }

    onValabilitateChange(selectedValabilitate: number) {
        this.selectedValabilitate = selectedValabilitate;
        if (this.selectedSlug !== '-1') {
            this.rerenderDT();
        } else {
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.clear().destroy();
                this.dtTrigger.next('');
            });
        }
    }

    loadRegistre() {
        this.registre$ = this.registreService
            .getRegistreUrbanism('active')
            .pipe(map((res: any) => [this.defaultParameter, ...res]));
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.slug = this.selectedSlug;
                dataTablesParameters.valabilitate = this.selectedValabilitate;

                this.http
                    .post<any>(
                        this.dtLink,
                        dataTablesParameters
                    )
                    .subscribe((res: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: res.data.recordsTotal,
                            recordsFiltered: res.data.recordsFiltered,
                            data: res.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            lengthMenu: [100],
            columns: [
                {
                    title: 'Crt.',
                    data: 'id',
                },
                {
                    title: 'Punct de lucru',
                    data: 'strada_name',
                    render: (data: any, type: any, row: any) => {
                        if (row.strada_name) {
                            return `<span>${row.strada_name}</span>`;
                        } else {
                            return '<span>N/A</span>';
                        }
                    },
                },
                {
                    title: 'Nr. acord/autorizație',
                    data: 'numar_certificat',
                    render: (data: any, type: any, row: any) => {
                        if (row.numar_certificat) {
                            return `<span>${row.numar_certificat}</span>`;
                        } else {
                            return '<span>N/A</span>';
                        }
                    },
                },
                {
                    title: 'Data emitere autorizație/acord',
                    data: 'document_data',
                }
            ],
        };
    }

    rerenderDT(paginate: boolean = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
    }

    // rerenderDT(paginate: boolean = false): void {
    //     this.isLoading = true;
    //     this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //         dtInstance.clear().draw();

    //         dtInstance.one('draw', () => {
    //             this.isLoading = false;
    //         }).draw(paginate);
    //     });
    // }

    backToRegistre() {
        this.backToRegistreClicked.emit();
    }
}
